import Queue from "nq-js";

class AddSchemaUseCase {
  execute(schema) {
    return new Queue.Schema().create(schema);
  }
}

export default AddSchemaUseCase;
